export default __webpack_public_path__ + "static/media/VideoPlaceHolder.2ad29b4e.jpg";